import React from 'react';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import './Services.scss';
import getServicesData from './ServiceData';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BsFillArrowRightCircleFill } from "react-icons/bs";

const Services = () => {
    const { t } = useTranslation();
    const ServicesData = getServicesData(t);
    // Show only first 6 services on main page
    const mainPageServices = ServicesData.slice(0, 6);
    
    return (
        <section className='service-section pt-100 pb-70' data-aos="fade-up">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-sm-6">
                        <SectionTitle title={t('services.title')} subTitle={t('services.subTitle')}/>
                    </div>
                    <div className="col-lg-6 col-sm-6">
                        <p className='service-title-text'>{t('services.description')}</p>
                    </div>
                </div>

                <div className="row">
                    {
                        mainPageServices.map((singleService, index) => (
                            <div key={index} className="col-lg-4 col-md-4 col-sm-6">
                                <div className="service-card-main">
                                    <div className="service-icon-main">
                                        {singleService.icon}
                                    </div>
                                    <div className="service-content-main">
                                        <h3>{singleService.title}</h3>
                                        <p>{singleService.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>

            <div className="services-link text-center">
                <Link to='/leistungen'>
                    {t('services.viewAll')}
                    <BsFillArrowRightCircleFill/>
                </Link>
            </div>
        </section>
    );
};

export default Services;